// src/routes/KaafiPayRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PendingOrders from '../pages/pos/PendingOrders';
import PosInvoiceJazira from '../pages/pos/PosInvoiceJazira';
import PosPendingInvoice from '../pages/pos/PosPendingInvoice';
import POSPage from '../pages/pos/POSPage';
import PosInvoice from '../pages/pos/PosInvoice';
 
const PosRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<POSPage />} />
       <Route path="/pending-orders" element={<PendingOrders />} />
         <Route  key="invoice" path="/invoice/:route/:id" element={<PosInvoice />} />,

        <Route path="/jaziira/:route/:id" element={<PosInvoiceJazira />} />
        <Route path="/pending/:route/" element={<PosPendingInvoice />} />
<Route path="/invoice/:route/:id" element={<PosInvoice />} />

      
       </Routes>
  );
};

export default PosRoutes;
